module.exports = function(app) {
    app.run(['Service', '$cookies', 'brandConfig', 'sessionData',
                function(Service, $cookies, brandConfig, sessionData) {
                    new Service({

                                    name: 'reasonCodesEprsvc',
                                    group:'eprsvc',
                                    url:'/eprsvc/x-services/secure/providers/v1/reasonCodes',

                                    fetch: function(payload) {
                                        // var cookieValue = brandConfig.getSharedBrandCodeFromLeafUBK( sessionData.employerInfo.brandName );
                                        // $cookies.put('umsBrand', cookieValue, { path: '/' });

                                        return this.get().then(
                                            function(response) {
                                              //$cookies.remove('umsBrand', { path: '/'});
                                                return response;
                                            }
                                        );
                                    }
                                });
                }
            ]);
};